import { AccountManagementEvent, AccountPageLoadEvent } from '@/services/analytics/events';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export enum RecentAndFavoriteOrdersToggleMode {
  Recents = 'recents',
  Favorites = 'favorites',
}

@Component({
  name: 'CmgRecentAndFavoriteOrdersToggle',
})
export default class CmgRecentAndFavoriteOrdersToggle extends Vue {
  @Prop({ required: true, type: String })
  mode!: RecentAndFavoriteOrdersToggleMode;

  get favoritesSelected(): boolean {
    return this.mode == RecentAndFavoriteOrdersToggleMode.Favorites;
  }

  onClickRecents() {
    this.switchTo(RecentAndFavoriteOrdersToggleMode.Recents);
    this.$services.analytics.send(new AccountPageLoadEvent('recents'));
    this.$services.analytics.send(new AccountManagementEvent(InteractionTrackingType.ClickRecents));
  }

  onClickFavorites() {
    this.switchTo(RecentAndFavoriteOrdersToggleMode.Favorites);
    this.$services.analytics.send(new AccountPageLoadEvent('favorites'));
    this.$services.analytics.send(new AccountManagementEvent(InteractionTrackingType.ClickFavorites));
  }

  switchTo(mode: RecentAndFavoriteOrdersToggleMode) {
    this.$emit('toggle', mode);
  }
}
